import { CreateFormWidget } from "Company/Components/Widgets/CreateFormWidget";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { PageContainer } from "Shared/Components/Container";

export const CompanyCreatePage = () => {
	const { t } = useResource();
	const companyResource = Resources.base.company;

	return (
		<PageContainer
			title={t(companyResource.shared.addNewCompany)}
			description="Company management"
		>
			<CreateFormWidget />
		</PageContainer>
	);
};
